export enum DocumentEditFieldType {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    TEXT = 'TEXT',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    CHECKBOX = 'CHECKBOX',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    RADIO = 'RADIO',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SELECT = 'SELECT',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    GROUP = 'GROUP',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    DATEPICKER = 'DATEPICKER',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SECTIONTITLE = 'SECTIONTITLE',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SUBSECTION = 'SUBSECTION',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SEARCHSELECT = 'SEARCHSELECT',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    LABEL = 'LABEL',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    FORMULA = 'FORMULA',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SELECT_MULTI = 'SELECT_MULTI'
}

/**
 * Tramo de clasificación de un campo LABEL. El valor numérico del campo
 * objetivo (`targetFieldId`) se compara contra `[min, max]` (cerrado en
 * ambos bordes) y, si cae dentro, se pinta el chip con `status` + `label`.
 */
export interface FieldTier {
    min: number;
    max: number;
    status: 'success' | 'warning' | 'danger' | string;
    label: string;
}

export interface DocumentEditField {
    id?: number | string;
    parentId?: number | string;
    showWhenValue?: string;
    hasChildren?: boolean;
    description?: string;
    checkboxes?: DocumentEditField[];
    editable: boolean;
    groupId: string | number;
    groupName: string;
    label: string;
    name: string;
    options: { label: string; value: string }[] | any[];
    order?: number;
    required: boolean;
    type: DocumentEditFieldType;
    value: any;
    visibility?: string;
    tiers?: FieldTier[];
    targetFieldId?: number;
    formula?: string;
}

export const createDocumentEditField = (data: any): DocumentEditField => ({
        id: data.id,
        parentId: data.parentId,
        showWhenValue: data.showWhenValue,
        hasChildren: data.hasChildren === true || String(data.hasChildren) === '-1' || String(data.hasChildren) === 'true',
        description: data.description ?? '',
        editable: data.editable === '-1' || data.editable === true,
        groupId: data.groupId ?? data.groupid ?? '0',
        groupName: data.groupname ?? '',
        label: data.label,
        name: data.name,
        options: data.options ? (typeof data.options === 'string' ? JSON.parse(data.options) : data.options) : [],
        order: data.order === '' ? undefined : Number(data.order),
        required: data.required === '-1' || data.required === true,
        type: DocumentEditFieldType[data.type?.toUpperCase() as keyof typeof DocumentEditFieldType] || data.type,
        value: data.value,
        visibility: data.visibility ?? ''
    });
